import { observer } from 'mobx-react-lite'
import { UpdateDeadlineDialog } from '@/features/jobs/details/components/UpdateDeadlineDialog'
import { type UpdateDeadlineDialogViewModel } from './UpdateDeadlineDialogViewModel'

export interface UpdateDeadlineDialogContainerProps {
  vm: UpdateDeadlineDialogViewModel
}

export const UpdateDeadlineDialogContainer = observer(
  function UpdateDeadlineDialogContainer({
    vm,
  }: UpdateDeadlineDialogContainerProps) {
    return (
      <UpdateDeadlineDialog
        showing={vm.modal.showing}
        deadline={vm.deadline}
        onDeadlineChange={vm.setDeadline}
        onClose={vm.modal.close}
        onUpdate={vm.update}
        isUpdatePending={vm.update.pending}
      />
    )
  },
)
